export default __webpack_public_path__ + "static/media/facebook.60551daf.svg";